
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { CustomThemeContext } from 'src/theme/ThemeProvider';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Logo from 'src/layouts/Logo';
import { styled } from '@mui/material/styles';
import SidebarMenu from './SidebarMenu';
import { customNavMode } from 'src/theme/custom.types';
interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

export const TopSection = styled(Box)(
  ({ theme }) => `
        height: 80px;
        padding-left: 20px;
        padding-top: 20px;
        margin-bottom: 10px;
        align-items: center;
`
);
const SidebarWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== 'navMode' })<{
  navMode?: customNavMode;
}>(
  ({ theme, navMode }) => `
        width: 280px;
        color: ${navMode == "dark" ? "white" : theme.sidebar.textColor};
        background: ${navMode == "white" ? theme.palette.background.paper : (navMode == "dark" ? "rgb(66, 66, 74)" : "transparent")};
        height: ${theme.sidebar.height};
        border-radius: ${theme.sidebar.borderRadius};
        margin-left: ${theme.sidebar.marginLeft};
        margin-top:${theme.sidebar.marginTop};;
        box-shadow: ${navMode == "transparent" ? "" : theme.sidebar.boxShadow}; 
`
);

const VersionBadge = styled(Box)(
  ({ theme }) => `
        background: ${theme.palette.primary.main};
        color: ${theme.palette.success.contrastText};
        padding: ${theme.spacing(0.4, 1)};
        text-align: right;
        display: inline-block;
        line-height: 1;
        font-size: ${theme.typography.pxToRem(13)};
        margin-left:180px;
        border-radius: 6px;
        margin-top:-5px;
`
);

export default function Sidebar(props: Props) {

  const themeContext = useContext(CustomThemeContext);
  return (
    <SidebarWrapper navMode={themeContext.navMode}>
      <Scrollbars autoHide>
        <TopSection>
          <Logo />
          <VersionBadge>{process.env.REACT_APP_VERSION}
          </VersionBadge>
        </TopSection>
        <SidebarMenu />
      </Scrollbars>
    </SidebarWrapper>
  );
}
